import { DataRecoveryLegalCaseGetters } from './partials/legal-case'

export const DataRecoveryGetters = {
  ...DataRecoveryLegalCaseGetters,

  isLoading: state => state.dataRecovery.isSearching,
}
